module.exports = __webpack_public_path__ + "img/48.0d38b782.jpg";